<script>
import { getCurrentInstance, onMounted, ref } from 'vue';
import commonFn from '@/commons/commonFunction';
import MsCheckbox from '../checkbox/MsCheckbox.vue';

export default {
  components: { MsCheckbox },
  props: {
    title: {
      type: String,
      default: 'title',
    },
    width: {
      type: Number,
      default: 400,
    },
    message: {
      type: [String, Array],
      default: '',
    },
    type: {
      type: Number,
      default: 0,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    textBtn: {
      type: String,
      default: null,
    },
    /**
     * Thêm optionList cho message có dạng chọn
     * tbngoc 22.07.2022
     */
    optionList: {
      type: Array,
      default: null,
    },
    customLabelIsShowMessage: {
      type: String,
      default: null,
    },

    /**
     * Object custom text của button VD: showConfirmValidate(message, title, width, customTextButton)
     */
    customTextButton: {
      type: Object,
      default: () => ({ Yes: 'Có', No: 'Không' }),
    },

    /**
     * Có focus vào control đầu tiền không
     */
    isFocusFirstControl: {
      type: Boolean,
      default: false,
    },
    /**
     * Icon và text
     */
    textIcon: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const { proxy } = getCurrentInstance();

    // Khi gọi hàm $close truyền đủ 2 tham số thì không cần khai báo hàm hày
    // function returnValue() {
    //   return true;
    // }

    const IsShowMessage = ref(true); // Dùng cho việc ẩn hiện thông báo sinh chứng từ
    const option = ref(1); // Option trả về
    onMounted(() => {
      //focus button
      if(props.isFocusFirstControl) {
        commonFn.focusFirstControl(proxy.$refs['msg']);
      }
    });

    function escPress(e, close) {
      e.preventDefault();
      close(this, null);
    }

    return {
      // returnValue,
      escPress,
      IsShowMessage,
      option,
    };
  },
};
</script>

<template>
  <!-- Đợi thiết kế chỉnh lại style sau -->
  <div class="msg-box" @keydown.esc="escPress($event, $close)">
    <div ref="msg" class="msg-center" :style="{ width: width + 'px' }">
      <div class="msg-title">
        {{ title }}
      </div>
      <div
        v-if="!hideClose"
        class="msg-close icon20 ic_close-grey-16"
        @click="
          $close(
            this,
            type == $ms.constant.MessageBoxType.confirm_Yes_No_Cancel ||
              type == $ms.constant.MessageBoxType.confirm_Custom
              ? null
              : false
          )
        "
      />
      <div class="msg-message">
        <template v-if="Array.isArray(message)">
          <div
            v-for="(item, i) in message"
            :key="i"
            class="msg-item"
            v-html="item"
          />
        </template>

        <div v-else class="msg-item" v-html="message" />
        <!-- confirm không hiện lại popup này lần sau -->
        <div
          v-if="type == $ms.constant.MessageBoxType.confirm_Show_Once"
          class="mt-1"
        >
          <ms-checkbox
            :label="customLabelIsShowMessage || 'Không hiển thị lần sau'"
            @change="IsShowMessage = !IsShowMessage"
          />
        </div>

        <div
          v-if="
            type == $ms.constant.MessageBoxType.confirm_Show_Once_With_Radio
          "
          class="flex mt-1"
        >
          <ms-radio
            v-for="(item, index) in optionList"
            :key="index"
            v-model="option"
            :label="item.text"
            name="rdnameMessageBox"
            :key-value="item.value"
            class="mb-2"
          />
          <div class="hr-row" />
          <ms-checkbox
            :label="customLabelIsShowMessage || 'Không hiển thị lần sau'"
            @change="IsShowMessage = !IsShowMessage"
          />
        </div>
      </div>

      <!-- alert: info/warning -->
      <div
        v-if="type == $ms.constant.MessageBoxType.confirm_Info_Warning"
        class="msg-buttons flex-end"
      >
        <ms-button
          class="msg-btn btn primary"
          :text="$t('i18nComponent.MessageBox.Close')"
          @click="$close(this, null)"
        />
        <!-- <button @click="$close(this, null)" class="msg-btn btn primary">
          {{ $t('i18nComponent.MessageBox.Accept') }}
        </button> -->
      </div>
      <!-- confirm yes_no-->
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirm_Yes_No"
        class="msg-buttons flex-row flex-end"
      >
        <ms-button
          class="msg-btn btn secondary"
          :text="$t('i18nComponent.MessageBox.No')"
          :has-border="true"
          @click="$close(this, false)"
        />
        <ms-button
          class="msg-btn btn"
          :text="$t('i18nComponent.MessageBox.Yes')"
          @click="$close(this, true)"
        />
      </div>
      <!-- confirm yes_no_cancel-->
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirm_Yes_No_Cancel"
        class="msg-buttons flex-row flex-end"
      >
        <ms-button
          class="msg-btn btn secondary"
          :text="customTextButton.Cancel"
          :has-border="true"
          @click="$close(this, null)"
        />

        <ms-button
          class="msg-btn btn secondary"
          :has-border="true"
          :text="customTextButton.No"
          @click="$close(this, false)"
        />

        <ms-button
          class="msg-btn btn"
          :text="customTextButton.Yes"
          @click="$close(this, true)"
        />
      </div>
      <!-- confirm delete-->
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirm_Delete"
        class="msg-buttons flex-row flex-end"
      >
        <div class="flex" />
        <ms-button
          type="secondary"
          :has-border="true"
          class="msg-btn btn secondary"
          :text="$t('i18nCommon.command.cancel2')"
          @click="$close(this, false)"
        />
        <ms-button
          type="danger"
          class="msg-btn btn danger"
          :text="$t('i18nCommon.command.delete')"
          @click="$close(this, true)"
        />
      </div>
      <!-- confirm Đóng -->
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirm_Close"
        class="msg-buttons flex-center"
      >
        <button class="msg-btn btn primary" @click="$close(this, null)">
          {{ $t('i18nComponent.MessageBox.Close') }}
        </button>
      </div>
      <!-- confirm yes_no-->
      <div
        v-else-if="
          type == $ms.constant.MessageBoxType.confirm_Yes_No_Once ||
            type == $ms.constant.MessageBoxType.confirm_Show_Once
        "
        class="msg-buttons flex-row flex-end"
      >
        <div class="flex" />
        <ms-button
          class="msg-btn btn secondary"
          :has-border="true"
          :text="customTextButton.No"
          @click="
            $close(
              this,
              type == $ms.constant.MessageBoxType.confirm_Show_Once
                ? {
                  answer: false,
                  IsShowMessage: IsShowMessage,
                }
                : false
            )
          "
        />
        <ms-button
          class="msg-btn btn primary"
          :text="customTextButton.Yes"
          @click="
            $close(
              this,
              type == $ms.constant.MessageBoxType.confirm_Show_Once
                ? {
                  answer: true,
                  IsShowMessage: IsShowMessage,
                }
                : true
            )
          "
        />
      </div>

      <div
        v-else-if="
          type == $ms.constant.MessageBoxType.confirm_Show_Once_With_Radio
        "
        class="msg-buttons flex-row"
      >
        <div class="flex" />
        <button
          class="msg-btn btn secondary-outline"
          @click="
            $close(this, {
              answer: false,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
        >
          {{ $t('i18nComponent.MessageBox.No') }}
        </button>
        <button
          class="msg-btn btn primary"
          @click="
            $close(this, {
              answer: true,
              IsShowMessage: IsShowMessage,
              option,
            })
          "
        >
          {{ $t('i18nComponent.MessageBox.Yes') }}
        </button>
      </div>

      <!-- confirm_custom thông báo xác nhận với button đóng được custom text NTDIEM 20/06/2023 -->
      <div
        v-else-if="type == $ms.constant.MessageBoxType.confirm_Custom"
        class="msg-buttons flex-between"
      >
        <!-- Các icon text -->
        <div>
          <div
            v-for="icon in textIcon"
            :key="icon"
            class="flex-center pointer"
            :class="icon.Class"
            @click="$close(this, icon.Answer)"
          >
            <div :class="icon.Icon" />
            <span :style="{'color': icon.TextColor}">{{ icon.Text }}</span>
          </div>
        </div>

        <!-- Các buttton -->
        <div class="flex-end">
          <ms-button
            v-for="btn in textBtn"
            :key="btn"
            class="msg-btn btn"
            :has-border="btn.HasBorder"
            :class="btn.Class"
            :text="btn.Text"
            @click="$close(this, btn.Answer)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsMessageBox.scss';
</style>
